var $window = $(window);
var breakPoint = 768;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//ヘッダースクロール
import {headerClass} from "../include/module";
headerClass();

//wp pagenavi
import {pagenaviURL} from "../include/module";
pagenaviURL();



// WEBPACK FOOTER //
// script.js